<template lang="pug">
  include ../Bemto
  +b.auth-modal.subscription-modal
    row(
      appearance="spaced"
      justify="center"
    )
      cell(cols="12")
        row(
          appearance="spaced"
          justify="center"
        )
          cell(cols="narrow")
            +b.IMG.block.ma--t-sm(
              width="64"
              src="/static/img/money.png"
            )
      cell(cols="12 8-md" style="margin-bottom: 8px")
        +b.P.text.--align-center.--weight-bold.--size-lg-sm.--color-black.--font-serif {{ _('Оплата плану') }}
    cell()
      +b.P.text.--font-serif.--align-center.--size-sm.--color-dark-gray.ma--t-2xxs.ma--b-xss.subscription-modal_text {{ _('Ви на крок ближче до користування платформою! Щоб розпочати, залишилось лише оформити річну підписку на платформу. Це відкриє вам доступ до вашої анкети.') }}
    cell()
      //- +b.P.text.--align-center.--size-sm.--color-dark-gray.ma--t-2xs.ma--b-lg {{ _('Переглянути свою анкету, додати свої фото, посилання на свої соціальні мережі можна вже зараз в особистому кабінеті.') }}
      +b.DIV.el-btn.--default.ma--b-lg.pay-button(
        v-if="false"
        @click="handleBuyClick"
      )
        +b.P.text.--color-white.--space-lg.--size-1sm.--transform-upper.--weight-bold {{ _('Перейти до оплати') }}
    +b.close-modal(
      @click.prevent='close'
    )
      +b.APP-ICON(name="icon-cross")
</template>

<script>
// import ChatBotModal from '@app/modals/ChatBotModal'

import { buySubscription } from '@requests/services/services';

export default {
  // mounted() {
  //   this.$once('hook:beforeDestroy', () => {
  //     this.$modal.show(ChatBotModal)
  //   })
  // },
  methods: {
    async handleBuyClick() {
      await buySubscription.execute().then(res => {
        localStorage.setItem('subscriptionShow', 'true');
        window.location.href = res?.liqpayUrl
      })
    },
    close() {
      localStorage.setItem('subscriptionShow', 'true');
      this.$emit('close');
    },
  },
}
</script>
<style lang="scss" scoped>
.subscription-modal {
  max-width: 440px;
  margin: 0 auto;

  &_text {
    font-family: Open Sans;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
}

.pay-button {
  margin-top: 40px;
  margin-bottom: 0;

  cursor: pointer;

  p {
   text-transform: none;
    letter-spacing: 0;
  }
}
</style>
<style>
.vm--modal {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
